import { useFormContext } from 'react-hook-form'
import BefehlFormAuftrag from '../Generic/BefehlFormAuftrag'
import { useTranslation } from 'react-i18next'

export interface Auftrag3_15FormProps {
  readOnly: boolean
  'data-testid': string
  activateEmptyFieldWarnings: boolean
}

export default function Auftrag3_15Form({
  readOnly,
  'data-testid': testId,
  activateEmptyFieldWarnings
}: Readonly<Auftrag3_15FormProps>) {
  const { control } = useFormContext()
  const { t } = useTranslation('ui-befehle')

  return (
    <BefehlFormAuftrag
      auftragKennung="3.15"
      label={t('auftraege.3_15.label')}
      fieldName="auftrag_3_15.enabled"
      control={control}
      readOnly={readOnly}
      testId={testId}
      activateEmptyFieldWarnings={activateEmptyFieldWarnings}
    >
      <span data-testid={`${testId}-text`}>{t('auftraege.3_15.label')}</span>
    </BefehlFormAuftrag>
  )
}
